export enum UserRole {
  Admin = 'ROLE_ADMIN',
  Creator = 'ROLE_CREATOR',
  Brand = 'ROLE_BRAND',
  BrandAdmin = 'ROLE_BRAND_ADMIN',
  Editor = 'ROLE_EDITOR',
}
